import { render, staticRenderFns } from "./AssetsAllocateEdit.vue?vue&type=template&id=6383791c&"
import script from "./AssetsAllocateEdit.vue?vue&type=script&lang=js&"
export * from "./AssetsAllocateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports